import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
import type React from 'react';
import useSession from '@/hooks/use-session';
import { DOCS_SITE_LOGIN_ROUTE, MCP_OAUTH_CALLBACK_ROUTE, TRANSITION_ROUTES } from '../../config/constants';
import DatadogReplayProvider from './components/datadog-replay-provider';
import Gate from './components/gate';
import OrgSwitcher from './components/org-switcher';
import PrivateLayout from './components/private-layout';
import PublicLayout from './components/public-layout';
import useRequestHeaders from './hooks/use-request-headers';
export type LayoutProps = {
  children: React.ReactNode;
  name?: string;
};

// Login bridges and OAuth popups: they require a dashboard session but render without navigation.
const SESSION_BRIDGE_ROUTES = [DOCS_SITE_LOGIN_ROUTE, '/authentication/mcp', MCP_OAUTH_CALLBACK_ROUTE];
const Layout = t0 => {
  const $ = _c(8);
  const {
    children,
    name: t1
  } = t0;
  const name = t1 === undefined ? "default" : t1;
  useRequestHeaders();
  const router = useRouter();
  const {
    isLoggedIn
  } = useSession();
  if (TRANSITION_ROUTES.includes(router.pathname)) {
    let t2;
    if ($[0] !== children) {
      t2 = <PublicLayout>{children}</PublicLayout>;
      $[0] = children;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  if (SESSION_BRIDGE_ROUTES.includes(router.pathname)) {
    let t2;
    if ($[2] !== children) {
      t2 = <Gate><PublicLayout>{children}</PublicLayout></Gate>;
      $[2] = children;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] !== children || $[5] !== isLoggedIn || $[6] !== name) {
    t2 = <DatadogReplayProvider><Gate>{isLoggedIn ? <OrgSwitcher><PrivateLayout name={name}>{children}</PrivateLayout></OrgSwitcher> : <PublicLayout>{children}</PublicLayout>}</Gate></DatadogReplayProvider>;
    $[4] = children;
    $[5] = isLoggedIn;
    $[6] = name;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default Layout;